import { Dispatch, SetStateAction } from "react";

import useQuoteFilters from "hooks/filters/useQuoteFilters";
import FilterAccordions from "components/organisms/Filter/components/FilterAccordions";

interface EditFilterProps {
  currentFilters: Record<string, any> | undefined;
  setFilters: Dispatch<SetStateAction<Record<string, any> | undefined>> | Function;
}

function EditQuoteFilter({ currentFilters, setFilters }: EditFilterProps) {
  const { config } = useQuoteFilters();

  const eventContext = "Edit Quote Preset";

  if (!currentFilters) return null;
  return (
    <FilterAccordions config={config} currentFilters={currentFilters} setFilters={setFilters} eventContext={eventContext} />
  );
}

export default EditQuoteFilter;
